import { ButtonV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import BundleStep from '../_components/Modals/BundleModal/BundleStep';
import { OUT_OF_STOCK } from '../_consts';
import { type PDPContextType, usePDPContext } from '../_contexts/PDPProvider';
import { useWizardStateContext } from '../_contexts/WizardStateProvider';
import WizStepId from './enums/WizStepId';
import { useStepCTA } from './hooks/useStepCTA';
import { getHref } from './utils/getHref';

const StepCTA = (): JSX.Element | null => {
  const {
    currentRoute,
    currentStep,
    isAccessory,
    isOuraRing4Wizard,
    stockStatus,
    nextButtonDisabled,
    isAddingToCart,
  } = useWizardStateContext();
  const { getFirstStockedFinish }: PDPContextType = usePDPContext();

  const step = useStepCTA();
  const { ctaMsgKey } = step;

  const isBundleStepOR4 =
    isOuraRing4Wizard &&
    stockStatus !== OUT_OF_STOCK &&
    currentStep === WizStepId.Size;
  const isBundleStepOR3 =
    !isAccessory && !isOuraRing4Wizard && currentStep === WizStepId.Size;
  const t = useTranslations();
  const href = getHref({
    currentRoute,
    currentStep,
    getFirstStockedFinish,
    isOuraRing4Wizard,
  });

  return (
    <>
      {/* add to cart CTA logic is handled in the bundle step for rings */}
      {isBundleStepOR4 || isBundleStepOR3 ? (
        <BundleStep />
      ) : (
        <ButtonV3
          aria-disabled={nextButtonDisabled}
          disabled={nextButtonDisabled}
          loading={isAddingToCart}
          size="large"
          href={!step.isLink ? undefined : href}
          {...step.buttonProps}
        >
          {t(ctaMsgKey)}
        </ButtonV3>
      )}
    </>
  );
};

export default StepCTA;
